import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {PromptApprovalConflict} from "../common/prompt-approval-conflict/prompt-approval-conflict";
import {reloadCart}             from "../store/actions/reload-cart";

export const ApprovalConflict = ({disabled, cart, store, next}) => cs(
    ["approvalConflict", ({}, next) => next(
        disabled ? (
            false
        ) : (
            cart.items.some((item) => item.approvalInfo?.approvalRequired) &&
            cart.items.some((item) => (
                !item.approvalInfo?.approvalRequired ||
                item.approvalInfo?.idOrderApproval !== cart.items[0].approvalInfo?.idOrderApproval
            ))
        ),
    )],
    ["promptApprovalConflict", ({}, next) => PromptApprovalConflict({
        cart,
        next,
    })],
    consumeContext("apis"),
    ({approvalConflict, apis, promptApprovalConflict}) => next({
        error: !approvalConflict ? null : {
            message: "There is a conflict in your cart's approval requirement",
            resolve: async () => {
                const count = {};
                for (const idOrderApproval of cart.items.map((item) => item.approvalInfo?.idOrderApproval)) {
                    count[idOrderApproval] = (count[idOrderApproval] || 0) + 1;
                }
                const keepIdOrderApproval = Object.keys(count).includes("undefined") ? undefined : Object.keys(count).reduce((a, b) => count[a] > count[b] ? a : b);
                const moveApprovalPending = await promptApprovalConflict({keepIdOrderApproval});
                if (moveApprovalPending) {
                    const itemIds = cart.items.filter((item) => (item.approvalInfo?.idOrderApproval != keepIdOrderApproval)).map((item) => item.itemId);
                    await apis.next.cart.deleteItemsFromCart({cartId: cart.cartId, itemIds: itemIds});
                    alert("Success! All approval orders have been moved to pending.");
                    await store.dispatch(reloadCart({apis}));
                }
            },
        },
    })
);
